import { render } from "./QuestionManagement.vue?vue&type=template&id=d8653f2c&scoped=true"
import script from "./QuestionManagement.vue?vue&type=script&lang=js"
export * from "./QuestionManagement.vue?vue&type=script&lang=js"

import "./QuestionManagement.vue?vue&type=style&index=0&id=d8653f2c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8653f2c"]])

export default __exports__